import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminBuildings_buildingIdSubmeters = z.any()
export type TagsGetAdminBuildings_buildingIdSubmeters = z.infer<typeof tagsGetAdminBuildings_buildingIdSubmeters>

export const paramsGetAdminBuildings_buildingIdSubmeters = z.object({ "buildingId": z.string().uuid() })
export type ParamsGetAdminBuildings_buildingIdSubmeters = z.infer<typeof paramsGetAdminBuildings_buildingIdSubmeters>

export const responseGetAdminBuildings_buildingIdSubmeters = z.object({ "payload": z.array(z.object({ "id": z.string().uuid(), "collectionPointId": z.string().uuid(), "parentSubmeterId": z.union([z.string().uuid(), z.null()]), "name": z.string(), "meterCodes": z.union([z.array(z.string()), z.null()]).optional(), "note": z.union([z.string(), z.null()]).optional(), "electricityRegisterMode": z.union([z.enum(["single","dual"]), z.null()]).optional(), "consumptionReminderEnabled": z.boolean(), "consumptionReminderStartDate": z.union([z.string().date(), z.null()]).optional(), "consumptionReminderFrequency": z.enum(["weekly","monthly","yearly"]), "order": z.number(), "createdAt": z.string().optional(), "updatedAt": z.string().optional() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminBuildings_buildingIdSubmeters = z.infer<typeof responseGetAdminBuildings_buildingIdSubmeters>

interface IGetAdminBuildings_buildingIdSubmeters extends BaseMethodType {
  tags: TagsGetAdminBuildings_buildingIdSubmeters,
  params: ParamsGetAdminBuildings_buildingIdSubmeters,
  response: ResponseGetAdminBuildings_buildingIdSubmeters
}
export const URL = '/admin/buildings/:buildingId/submeters'
export const validation = {
  get: {
    tags: tagsGetAdminBuildings_buildingIdSubmeters,
    params: paramsGetAdminBuildings_buildingIdSubmeters,
    response: responseGetAdminBuildings_buildingIdSubmeters
  }
}
export interface AdminBuildings_buildingIdSubmeters extends BaseRouteType {
  get: IGetAdminBuildings_buildingIdSubmeters
}